import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SubscriptionDeviceUsage } from '$components/subscription-dialog/subscription-device-usage/subscription-device-usage';
import { SubscriptionNeedMoreDevices } from '$components/subscription-dialog/subscription-device-usage/subscription-need-more-devices';
import { subscriptionNavigationPath } from '$components/subscription-dialog/subscription-dialog';

export interface NotEnoughDevicesDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  licensedDevices?: number;
  usedDevices?: number;
}

export function NotEnoughDevicesDialog({
  isOpen,
  onOpenChange,
  licensedDevices,
  usedDevices,
}: NotEnoughDevicesDialogProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Dialog isOpen={isOpen} onOpenChange={onOpenChange} className="w-max-4xl">
      <div className="flex flex__ai--center m-bottom-xxl">
        <Dialog.Title className="m-bottom-xxs">{t('addDevice.add')}</Dialog.Title>
      </div>
      <Dialog.Description />

      <div className="flex flex__dir--column gap-l">
        <SubscriptionDeviceUsage
          licensedDevices={licensedDevices}
          usedDevices={usedDevices}
        />
        <SubscriptionNeedMoreDevices />
      </div>

      <Dialog.Actions>
        <Dialog.Close>
          <Button variant="secondary">{t('shared.close')}</Button>
        </Dialog.Close>
        <Button variant="primary">
          <Link
            to={subscriptionNavigationPath}
            target="_blank"
            className="flex flex__ai--center"
          >
            {t('subscription.manageSubscription')}
            <Icon
              name="external-link"
              size={IconSizeClasses.XXSmall}
              className="m-left-s bg-white"
            />
          </Link>
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
